module.exports = __webpack_public_path__ + "static/img/ios_code.8a2f024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ios_code.png
// module id = pCsh
// module chunks = 1